<div class="card-wrapper">
  <div class="d-flex flex-column justify-content-center align-items-center" *ngIf="gameCard.statusType"
    [ngClass]="gameCard.statusType === PRIZE_STATUS.NON_COMPATIBLE ? 'non-compatible-wrapper': 'status-banner'"
    [ngSwitch]="gameCard.statusType">
    <div *ngSwitchCase="PRIZE_STATUS.WITHDRAWN"
      class="d-flex flex-row justify-content-center align-items-center withdrawn-banner p-2">
      <div class="img-round-bg d-flex flex-column justify-content-center align-items-center">
        <img src="assets/images/lootboxes/check-box-tick.svg" alt="" class="img-12" />
      </div>
      <span class="info">{{"withdrawn" | translate | uppercase}}</span>
    </div>
    <div *ngSwitchCase="PRIZE_STATUS.KEPT"
      class="d-flex flex-row justify-content-center align-items-center withdrawn-banner p-2">
      <div class="img-round-bg d-flex flex-column justify-content-center align-items-center">
        <img src="assets/images/lootboxes/check-box-tick.svg" alt="" class="img-12" />
      </div>
      <span class="info">{{"won" | translate}}</span>
    </div>
    <div *ngSwitchCase="PRIZE_STATUS.WON"
      class="d-flex flex-row justify-content-center align-items-center withdrawn-banner p-2">
      <div class="img-round-bg d-flex flex-column justify-content-center align-items-center">
        <img src="assets/images/lootboxes/check-box-tick.svg" alt="" class="img-12" />
      </div>
      <span class="info">{{"won" | translate | uppercase}}</span>
    </div>
    <div *ngSwitchCase="PRIZE_STATUS.NON_COMPATIBLE"
      class="d-flex flex-row justify-content-center align-items-center non-compatible-banner p-2">
      <div class="img-round-bg d-flex flex-column justify-content-center align-items-center">
        <img src="assets/images/svg-icons/x-close-white.svg" alt="" class="img-12" />
      </div>
      <span class="info">{{"non_compatible" | translate | uppercase}}</span>
    </div>
    <div *ngSwitchDefault class="d-flex flex-column justify-content-center align-items-center cash-swap-banner p-2">
      <div class="d-flex flex-column justify-content-center align-items-center gap-sm-2 gap-2 p-2 main-content">
        <img [src]="gameCard.unit === CURRENCY.USD ? 'assets/images/svg-icons/usd-coin.svg' : 'assets/images/svg-icons/euro-coin.svg'" alt="" srcset="" class="wsm-logo-wrapper" />
        <p>
          <sub>{{gameCard.unit === CURRENCY.USD ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO}}</sub>
          <span>{{ convertNumToCurr(gameCard.value)}}</span>
        </p>
      </div>
      <div class="d-flex flex-row justify-content-center align-items-center gap-sm-1 gap-1 footer-content">
        <div class="d-flex flex-column justify-content-center align-items-center img-round-bg">
          <img src="assets/images/lootboxes/coin-swap.svg" alt="" class="img-12" />
        </div>
        <span class="info">{{"cash_swap" | translate | uppercase}}</span>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column p-3 gap-sm-1 gap-1 nft-card cursor-pointer"
    (click)="onAction.emit({action:ACTIONS.CLICK})">
    <div *ngIf="gameCard.title" class="d-flex flex-row justify-content-between align-items-center nft-card-title">
      <div class="form-check d-flex flex-row align-items-center nft-name gap-sm-1 gap-1"
        [ngClass]="{ 'form-check': gameCard.checkbox?.hasCheckBox}">
        <input *ngIf="gameCard.checkbox?.hasCheckBox" class="form-check-input" type="checkbox" value=""
          id="flexCheckDefault" [checked]="gameCard.checkbox?.isChecked" (click)="$event.stopPropagation()"
          (change)="onAction.emit({action:ACTIONS.CHECK_BOX, data: gameCard.checkbox?.isChecked})" />
        <p [tooltip]="gameCard.title" [ngClass]="{'m-0': !gameCard.checkbox?.hasCheckBox}"
          [tooltipEnable]="!!(!!gameCard.title && gameCard.title.length > (isMobile ? 15 : 28))"
          containerClass="tooltipClass">
          <!-- #{{ getEllipsis(gameCard.title.toString() || '', 28) }}</p> -->
          {{gameCard.title}}
      </div>
    </div>
    <p *ngIf="(gameCard.type !== SPIN_WIN_PRIZES.NFT) && gameCard.name" [tooltip]="gameCard.name" class="m-0 nft-card-title non-nft-title"
      [tooltipEnable]="!!(gameCard?.name && gameCard.name!.length > (isMobile ? 15 : 28))"
      containerClass="tooltipClass">
      <!-- {{ getEllipsis(gameCard.name || '', 28) }} -->
      {{gameCard.name}}
    </p>
    <div *ngIf="gameCard.type === SPIN_WIN_PRIZES.NFT || gameCard?.desc"
      class="d-flex flex-row align-items-center gap-sm-2 gap-2">
      <span class="nft-card-info mr-1" [tooltip]="gameCard?.desc"
        [tooltipEnable]="!!(gameCard?.desc && gameCard.desc!.length > (isMobile ? 10 : 18))"
        containerClass="tooltipClass">
        <!-- {{ getEllipsis(gameCard.desc || '', 18) }} -->
        {{gameCard.desc}}
      </span>
      <ng-container *ngIf="gameCard.type === SPIN_WIN_PRIZES.NFT">
        <span class="dot"></span>
        <span class="nft-card-info-price">{{gameCard.unit === CURRENCY.USD ? CURRENCY_SYMBOL.USD :
          CURRENCY_SYMBOL.EURO}}{{
          convertNumToCurr(gameCard.value)}}</span>
      </ng-container>
    </div>
    <app-custom-image class="nft-card-img mt-1" [src]="gameCard.gameHeroImage ? gameCard.gameHeroImage : (gameCard.type === SPIN_WIN_PRIZES.NFT || gameCard.type === SPIN_WIN_PRIZES.CUSTOM) ? gameCard.img : gameCard.type === SPIN_WIN_PRIZES.FREE_SPIN
      ? 'assets/images/lootboxes/free-spin-lootbox.svg' : gameCard.type === SPIN_WIN_PRIZES.CASH ? '/assets/images/cash-reward-card.png'
      : 'assets/images/token-chest-card.png'" [alt]="'game-image'"></app-custom-image>
    <span *ngIf="gameCard.items" class="nft-card-items">{{ gameCard.items }}
      {{
      (gameCard.items && gameCard.items > 1 ? "items" : "item") | translate
      }}</span>
    <button *ngIf="gameCard.fees" class="purchase-btn primary-btn">
      {{"open_for" | translate | uppercase}} {{gameCard.unit === CURRENCY.USD ? CURRENCY_SYMBOL.USD :
      CURRENCY_SYMBOL.EURO}}{{ convertNumToCurr(gameCard.fees)}}
    </button>
  </div>
</div>